import { createFileRoute } from '@tanstack/react-router';

import { SupplierManagementPage } from '@/areas/suppliers/Suppliers/SupplierManagementPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/suppliers/_sidebar/')({
    staticData: { access: { permissions: ['view:supplier'] }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SupplierManagementPage />;
}
